// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76e491d0","239":"4a9cd4ff","455":"f16c7949"}[chunkId] + ".chunk.js";
};